<template>
  <!-- 版权说明 -->
  <div>
    <div class="main">
      <div class="breadcrumb">
        <span>首页</span>
        <span>></span>
        <span>版权说明</span>
      </div>
      <div class="main-content">
        <div class="content-l">
          <div class="privacy">
            <p class="title">版权说明</p>
            <p>第一财经杂志网站定义的网络服务内容包括：</p>
            <p>文字、软件、声音、图片、录像、图表、广告中的全部内容；</p>
            <p>电子邮件的全部内容；</p>
            <p>第一财经杂志网站为用户提供的其他信息。</p>
            <p>所有这些内容受版权、商标、标签和其它财产所有权法律的保护。</p>
            <p>所以，用户只能在第一财经杂志网站和广告商授权下才能使用这些内容，而不能擅自复制、再造这些内容、或创造与内容有关的派生产品。</p>
            <p>第一财经杂志网站所载第一财经电视、第一财经频率以及第一财经日报的内容版权归第一财经所有，第一财经杂志网站拥有转授授权，任何人需要转载第一财经杂志网站的文章，必须征得第一财经杂志网站同意授权。</p>
            <p>
              <strong>图片合作 Pictures</strong>
            </p>
            <p>新华社、人民视觉、视觉中国、IC photo、人民视觉</p>
            <p>部分图片来自网络，如有疑问可联系zkkf@cbnweek.com</p>
            <p>
              <strong>内文字体提供 Fonts</strong>
            </p>
            <p>本刊所使用方正字体经方正集团旗下之方正信产集团授权许可</p>
            <p>
              <strong>法务 Legal</strong>
            </p>
            <p>郑雪芬</p>
          </div>
        </div>
        <div class="content-r">
          <Wechart></Wechart>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Wechart from "@/components/wechart";
import { getTdkList} from "@/api/tdk";
export default {
  components: {
    Wechart
  },
  data() {
    return {};
  },
  created() {
    getTdkList({column:0}).then(res => {
      console.log(res)
      const head = document.getElementsByTagName('head')
      const meta = document.createElement('meta')
      document.title= res.data.data[0].title;
      document.querySelector('meta[name="keywords"]').setAttribute('content',res.data.data[0].keyword)
      document.querySelector('meta[name="description"]').setAttribute('content', res.data.data[0].describe)
      head[0].appendChild(meta)
    })
  }
};
</script>
<style lang="scss" scoped>
.breadcrumb {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
  padding-top: 20px;
  padding-bottom: 16px;
  span:last-child {
    color: #0091ff;
  }
}
.privacy {
  padding: 30px;
  background: #ffffff;
  margin-bottom: 60px;
  text-align: justify;
  .title {
    font-weight: bold;
  }
  p {
    font-size: 16px;
    line-height: 36px;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/footer/copyright.vue